module.exports = __webpack_public_path__ + "img/brandstory_img4.0ace153e.png";